// packages
import dayjs from 'dayjs';

// types
import { UseEntityOptionColumnsReturnType } from './EntitySearch.types';
import { useDebounceValue } from 'usehooks-ts';
import { useMemo } from 'react';

export const useEntityOptionColumns = ({
  mode
}): UseEntityOptionColumnsReturnType => {
  return [
    {
      key: 'label',
      width: 'minmax(0, 150px)'
    },
    {
      key: 'group',
      width: '100px',
      hidden: mode === 'compact'
    },
    {
      key: 'number',
      width: '60px'
    },
    {
      key: 'birthDate',
      width: '80px',
      hidden: mode === 'compact',
      valueFormatter: (value?: string | Date) => {
        return value ? dayjs(value).format('DD-MM-YYYY') : '';
      }
    }
  ];
};

export const useDebounceWithStatus = <T>(
  val: T,
  delay: number
): [T, boolean] => {
  const [debounced] = useDebounceValue(val, delay);

  const isDebouncing = useMemo(() => debounced != val, [val, debounced]);

  return [debounced, isDebouncing];
};
